import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { TERMS_OF_USE_LINK, PRIVACY_POLICY_LINK } from '../../shared/links';
import styles from './AgreementText.css';

const cx = classnames.bind(styles);

function AgreementText({ className, legalLinks = { privacyPolicy: PRIVACY_POLICY_LINK, termsOfUse: TERMS_OF_USE_LINK } }) {
    return (
        <p className={cx('agreementText', className)}>
            By proceeding, you agree with
            <br />
            <CustomLink
                to={legalLinks.termsOfUse}
                target='_blank'
            >
                Terms&nbsp;of&nbsp;Service
            </CustomLink>
            {' and '}
            <CustomLink
                to={legalLinks.privacyPolicy}
                target='_blank'
            >
                Privacy&nbsp;Policy
            </CustomLink>
        </p>
    );
}

AgreementText.propTypes = {
    className: PropTypes.string,
    legalLinks: PropTypes.object
};

AgreementText.defaultProps = {
    className: ''
};

export {
    AgreementText
};
